import React from 'react';
import { useNavigate } from "react-router-dom";
import useAuth from "./useAuth";
import Header from './Header';
import { useTranslation } from 'react-i18next';
import "./style.css";

const AuthErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div>
        <Header />
        <div className="access-denied-wrapper">
            <div className="access-denied-card">
                <div className="access-denied-icon">🔒</div>
                <h1 className="access-denied-title">{t('xUsers.denied.title')}</h1>
                <p className="access-denied-message">
                    {t('xUsers.denied.message')}
                </p>
                <div className="access-denied-actions">
                    <button onClick={() => navigate("/")} className="access-btn access-btn-secondary">
                        {t('xUsers.denied.home')}
                    </button>
                    <button onClick={logout} className="access-btn access-btn-primary">
                        {t('xUsers.denied.relogin')}
                    </button>
                </div>
            </div>
        </div>

        <style jsx="true">{`
            .access-denied-wrapper {
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: calc(100vh - 60px);
                padding: 24px;
            }
            .access-denied-card {
                background: white;
                border-radius: 16px;
                box-shadow: 0 4px 24px rgba(0, 0, 0, 0.1);
                padding: 48px 40px;
                max-width: 420px;
                width: 100%;
                text-align: center;
            }
            .access-denied-icon {
                font-size: 56px;
                margin-bottom: 20px;
            }
            .access-denied-title {
                font-size: 1.75rem;
                font-weight: 700;
                color: #111;
                margin: 0 0 12px;
            }
            .access-denied-message {
                font-size: 1rem;
                color: #666;
                margin: 0 0 32px;
                line-height: 1.5;
            }
            .access-denied-actions {
                display: flex;
                gap: 12px;
                justify-content: center;
            }
            .access-btn {
                padding: 11px 24px;
                border-radius: 8px;
                font-size: 0.95rem;
                font-weight: 600;
                cursor: pointer;
                border: 2px solid black;
                transition: background 0.15s, color 0.15s;
            }
            .access-btn-primary {
                background: black;
                color: white;
            }
            .access-btn-primary:hover {
                background: #333;
            }
            .access-btn-secondary {
                background: white;
                color: black;
            }
            .access-btn-secondary:hover {
                background: #f0f0f0;
            }
        `}</style>
    </div>
  );
};

export default AuthErrorPage;
